var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5355 51.4645C56.5829 49.5118 53.4171 49.5118 51.4645 51.4645C49.5118 53.4171 49.5118 56.5829 51.4645 58.5355L58.5355 51.4645ZM124 129C126.761 129 129 126.761 129 124V79C129 76.2386 126.761 74 124 74C121.239 74 119 76.2386 119 79V119H79C76.2386 119 74 121.239 74 124C74 126.761 76.2386 129 79 129H124ZM51.4645 58.5355L120.464 127.536L127.536 120.464L58.5355 51.4645L51.4645 58.5355Z",
    fill: "#0382BA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 89.5,
    r: 89,
    stroke: "#0382BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowservice);
export default __webpack_public_path__ + "static/media/arrowservice.22df702f4a2b3d29ba6401dae9076e4a.svg";
export { ForwardRef as ReactComponent };